module.exports = __webpack_public_path__ + "static/media/introduction-cover.d4d32aee.jpg";